import Trip = API_CreateBooking.Trip;
import Place = API_CreateBooking.Place;
import Flight = API_CreateBooking.Flight;
import Pickup = API_CreateBooking.Pickup;
import TransferPoint = API_CreateBooking.TransferPoint;
import moment from 'moment';
import { pageLang } from '../../../services/app-storage';
import { IWidgetFormRow } from '../models/form';
import { BookingMode, currentMode, isDesktop } from '../storage';

export default function createTrips(formRow: IWidgetFormRow, noFlight: boolean): Trip[] {

    // Check if in noflight mode
    const isDTD = currentMode.value === BookingMode.DoorToDoor;

    // Collect flight number and date
    const flightNumber = formRow.flight.getFlightID() || 0;
    let flightDate = formRow.flight.flightDate.value;
    if (isDesktop) {
        flightDate = moment(flightDate, 'll', pageLang).format('YYYY-MM-DD')
            || flightDate;
    }

    // Collect booking-mode information
    const isReturn = formRow.isReturn;

    const hasToAirport = isDTD
        || isReturn && formRow.bookingMode === BookingMode.FromAirport
        || !isReturn && formRow.bookingMode === BookingMode.ToAirport;

    const hasFromAirport = isDTD
        || isReturn && formRow.bookingMode === BookingMode.ToAirport
        || !isReturn && formRow.bookingMode === BookingMode.FromAirport;

    const result: Trip[] = [];

    if (noFlight) {
        const points = getNoFlight(formRow);
        result.push(createTrip(points.from, points.to));
    } else {
        // To airport
        if (hasToAirport) {
            const fromPlace = formRow.fromAddress;
            const pickupDT = formRow.noflight.datetime.getMoment();

            const selectedPlace = fromPlace.selectedResult;
            if (!selectedPlace) throw new ReferenceError('No place result is selected!');

            const pickupP: (Place | TransferPoint) & Partial<Pickup> = mapApiLocationToPoint(selectedPlace);

            if (!isDTD && pickupDT) {
                pickupP.PickupTime = pickupDT.format('YYYY-MM-DDTHH:mm:ss');
            }

            const dropoffA: Flight = {
                Airport: {
                    FlightId: flightNumber,
                    FlightDate: flightDate
                }
            };

            result.push(createTrip(pickupP, dropoffA));
        }

        // From airport
        if (hasFromAirport) {
            const pickupA: Flight = {
                Airport: {
                    FlightId: flightNumber,
                    FlightDate: flightDate
                }
            };

            const selectedPlace = formRow.toAddress.selectedResult;
            if (!selectedPlace) throw new ReferenceError('No place result is selected!');

            result.push(createTrip(pickupA, mapApiLocationToPoint(selectedPlace)));
        }
    }

    return result;
}

function mapApiLocationToPoint(selectedPlace: API.ApiLocation): Place | TransferPoint {

    switch (selectedPlace.type) {
        case 'Place':
            return { PlaceID: selectedPlace.id };
        case 'Airport':
            return {
                TransferPoint: {
                    Id: selectedPlace.id,
                    Type: selectedPlace.type
                }
            };
        case 'Trainstation':
            return {
                TransferPoint: {
                    Id: selectedPlace.id,
                    Type: selectedPlace.type
                }
            };
    }
}

function getNoFlight(formRow: IWidgetFormRow): { from: (Place | TransferPoint) & Pickup, to: Place | TransferPoint } {
    const point = formRow.noflight;
    const fromLocation = point.from ? point.from.selectedResult : null;
    const toLocation = point.to ? point.to.selectedResult : null;

    if (!fromLocation || !toLocation) {
        throw new Error('From or to not filled in');
    }

    const pickupDT = formRow.noflight.datetime.getMoment();

    return {
        from: {
            ...mapApiLocationToPoint(fromLocation),
            PickupTime: pickupDT!.format('YYYY-MM-DDTHH:mm:ss')
        },
        to: {
            ...mapApiLocationToPoint(toLocation)
        }
    };
}

function createTrip(
    from: (Place | Flight | TransferPoint) & Partial<Pickup>,
    to: Place | Flight | TransferPoint): Trip {
    return {
        SortNumber: 1,
        Passengers: 1,
        Bags: 0,
        Pickup: from as (Place | Flight | TransferPoint) & Pickup,
        Dropoff: to
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-core/submit/trip-creator.ts